import { useGet } from '../../../sharedModules/hooks/useQuery';
import { MissingInvoice } from '../model';

export const MISSING_INVOICES_URL = '/collections/missing_invoices';

// Location is part of the key: Tampa and Pittsburgh are separate lists that must cache and
// invalidate independently.
export const missingInvoicesQueryKey = (location: string) => [MISSING_INVOICES_URL, { location }] as const;

export function useMissingInvoices(location: string, enabled = true) {
  return useGet<MissingInvoice[]>(
    {
      url: MISSING_INVOICES_URL,
      params: { location },
      enabled,
    },
    // File-picker blur/focus would otherwise refetch the full builder mid-upload.
    { refetchOnWindowFocus: false },
  );
}
